import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { MarketdateStatus } from './marketdate-status.model';
import { MarketdateStatusPopupService } from './marketdate-status-popup.service';
import { MarketdateStatusService } from './marketdate-status.service';

@Component({
    selector: 'jhi-marketdate-status-delete-dialog',
    templateUrl: './marketdate-status-delete-dialog.component.html'
})
export class MarketdateStatusDeleteDialogComponent {

    marketdateStatus: MarketdateStatus;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateStatusService: MarketdateStatusService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateStatusService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateStatusListModification',
                content: 'Deleted an marketdateStatus'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-status-delete-popup',
    template: ''
})
export class MarketdateStatusDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateStatusPopupService: MarketdateStatusPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdateStatusPopupService
                .open(MarketdateStatusDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status-delete-dialog.component.ts